//  var serverUrl = "http://192.168.11.125:8081";
//  var serverUrl = "http://localhost:8000";
// var serverUrl = "http://192.168.2.180:8081";
// var serverUrl = "https://idedata.digitalglyde.com";
var serverUrl = "https://ideportalbackend.azurewebsites.net"
// var serverUrl = "https://idedemodata.digitalglyde.com";
// var serverUrl = "https://customerappdata.wss-corp.com";

// let appVersion = ""
// if (process.env.NODE_ENV === 'production') {
//     serverUrl = ''; 
// }

export const settings = {
    //   env: process.env.NODE_ENV,
    serverUrl,
    //   appVersion
};

export default settings;